<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Whole Church Sings</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT"><a id="page_iv">Contents</a></p><a id="page_iv">
</a><p class="TOC_fbm1" id="pre001"><a id="page_iv"></a><a href="#/xhtml/preface#pre001">Preface</a></p>
<p class="TOC_fbm" id="abb001"><a href="#/xhtml/abbreviations#abb001"><i>Abbreviations</i></a></p>
<p class="TOC_ch" id="ch001"><a href="#/xhtml/chapter001#ch001">1. The Reformation Celebrated in Song</a></p>
<p class="TOC_ch" id="ch002"><a href="#/xhtml/chapter002#ch002">2. Pre-Reformation Vernacular Song</a></p>
<p class="TOC_ch" id="ch003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3. Wittenberg Reforms, 1517–23</span></p>
<p class="TOC_ch" id="ch004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4. The Initial Repertory of Hymns, 1523–24</span></p>
<p class="TOC_ch" id="ch005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5. The Publication of the Wittenberg Hymns, 1523–24</span></p>
<p class="TOC_ch" id="ch006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6. A Congregational Hymnal in Wittenberg, 1524–26</span></p>
<p class="TOC_ch" id="ch007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7. Liturgical Developments in Wittenberg, 1523–26</span></p>
<p class="TOC_ch" id="ch008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8. From Enchyridion to Geistliche lieder, 1524–29</span></p>
<p class="TOC_app" id="app001"><span href="#/xhtml/appendix001#app001" title="Link target outside of Sample"><i>Appendix 1</i></span></p>
<p class="TOC_app_title"><span href="#/xhtml/appendix001#app001" title="Link target outside of Sample"><i>Enchyridion geistlicher gesenge und psalmen fur die leyen</i>, Wittenberg, 1524–26</span></p>
<p class="TOC_app" id="app002"><span href="#/xhtml/appendix002#app002" title="Link target outside of Sample"><i>Appendix 2</i></span></p>
<p class="TOC_app_title"><span href="#/xhtml/appendix002#app002" title="Link target outside of Sample"><i>Geistliche Lieder</i>, Wittenberg: Klug, 1529/33</span></p>
<p class="TOC_app" id="app003"><span href="#/xhtml/appendix003#app003" title="Link target outside of Sample"><i>Appendix 3</i></span></p>
<p class="TOC_app_title"><span href="#/xhtml/appendix003#app003" title="Link target outside of Sample">Luther’s Hymns and Liturgical Chants in Critical Editions and Hymnals</span></p>
<p class="TOC_app" id="app004"><span href="#/xhtml/appendix004#app004" title="Link target outside of Sample"><i>Appendix 4</i></span></p>
<p class="TOC_app_title"><span href="#/xhtml/appendix004#app004" title="Link target outside of Sample">Hymns by Authors Other than Luther</span></p>
<p class="TOC_app" id="app005"><span href="#/xhtml/appendix005#app005" title="Link target outside of Sample"><i>Appendix 5</i></span></p>
<p class="TOC_app_title"><span href="#/xhtml/appendix005#app005" title="Link target outside of Sample">Hymn Collections, 1524–36</span></p>
<p class="TOC_fbm" id="bib001"><a id="page_vi"></a><span href="#/xhtml/bibliography#bib001" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="TOC_fbm" id="ind001"><span href="#/xhtml/index001#ind001" title="Link target outside of Sample"><i>Index of First Lines</i></span></p>
<p class="TOC_fbm" id="ind002"><span href="#/xhtml/index002#ind002" title="Link target outside of Sample"><i>Index of Names and Subjects</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7165fa61